import { convertModelToFormData, convertModelToFormDataForNestedFiles } from './helpers';
import { qportalApi } from './qportal-api';
const updateFreelancerAccount = async (freelancer) => {
    const formData = convertModelToFormData(freelancer);
    return qportalApi.postForm('users', formData);
};
const updateFreelancerUserAccount = async (freelancer) => {
    const formData = convertModelToFormDataForNestedFiles(freelancer);
    return qportalApi.postForm('users/UpdateFreelancerUserAsync', formData);
};
const uploadProfilePicture = async (file) => {
    const obj = { ProfilePicture: file };
    const formData = convertModelToFormData(obj);
    return qportalApi.postForm('users/uploadProfilePicture', formData);
};
const getFreelancerAccount = () => {
    return qportalApi.get('users/profile');
};
const getFreelancerAccountById = (userId) => {
    return qportalApi.get(`users/${userId}/profile`);
};
const getFreelancerProfile = () => {
    return qportalApi.get('users/viewProfile');
};
const FreelancerApi = {
    updateFreelancerAccount,
    updateFreelancerUserAccount,
    getFreelancerAccount,
    getFreelancerProfile,
    uploadProfilePicture,
    getFreelancerAccountById
};
export default FreelancerApi;
